import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { getAdminUserFromEmail } from "../../utils/adminApi";
import {
  formatCellValue,
  normalizeRecord,
  pickValue,
} from "./adminValueUtils";

function AdminUserLookupSection() {
  const [email, setEmail] = useState("");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSearch = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    try {
      setLoading(true);
      setError("");
      const data = await getAdminUserFromEmail(email.trim());
      setUser(data);
    } catch (err) {
      console.error(err);
      setUser(null);
      setError(err.message || "Неуспешно пребарување по е-пошта.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="admin-card">
      <CardContent>
        <Typography variant="h6" mb={2}>
          User From Email
        </Typography>

        <Box component="form" onSubmit={onSearch}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1} mb={2}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              size="small"
            />
            <Button type="submit" variant="contained" disabled={loading}>
              Search
            </Button>
          </Stack>
        </Box>

        {error ? <Alert severity="error">{error}</Alert> : null}

        {user ? (() => {
          const normalizedUser = normalizeRecord(user);
          const userId = pickValue(normalizedUser, ["id", "user_id", "userId", "uid"]);
          const userEmail = pickValue(normalizedUser, [
            "email",
            "user_email",
            "userEmail",
          ]);
          const firebaseUid = pickValue(normalizedUser, [
            "firebase_uid",
            "firebaseUuid",
            "firebase_uuid",
            "firebaseUid",
            "firebase_id",
            "firebaseId",
            "uuid",
          ]);
          const role = pickValue(normalizedUser, ["role", "user_role", "userRole"]);

          return (
            <Box className="admin-table-wrap">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Firebase UID</TableCell>
                    <TableCell>Role</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{formatCellValue(userId)}</TableCell>
                    <TableCell>{formatCellValue(userEmail)}</TableCell>
                    <TableCell>{formatCellValue(firebaseUid)}</TableCell>
                    <TableCell>{formatCellValue(role)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          );
        })() : null}
      </CardContent>
    </Card>
  );
}

export default AdminUserLookupSection;
